import { render, staticRenderFns } from "./VoiceInviteConfirm.vue?vue&type=template&id=1ae4ad73&scoped=true"
import script from "./VoiceInviteConfirm.vue?vue&type=script&lang=js"
export * from "./VoiceInviteConfirm.vue?vue&type=script&lang=js"
import style0 from "./VoiceInviteConfirm.vue?vue&type=style&index=0&id=1ae4ad73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4ad73",
  null
  
)

export default component.exports